<div
    ng-form="fieldRecordFormerTenureForm"
    class="well">
    <h5 ng-bind="$ctrl.selectedPurpose.formerTenureLabel">{{selectedPurpose.formerTenureLabel}}</h5>

    @if (selectedPurposeSubjectOfPlans.length) {
        <div class="row">
            <div class="col-xs-12">
                <label class="control-label required-input">Former tenure subject of plan</label>
                <div
                    class="input-group"
                    ng-class="{'has-error': fieldRecordFormerTenureForm.formerTenureSubjectOfPlan.$error.required && fieldRecordFormerTenureForm.formerTenureSubjectOfPlan.$dirty}">
                    @for (option of selectedPurposeSubjectOfPlans; track option) {
                        <label class="nlr-radio">
                            <input
                                type="radio"
                                name="formerTenureSubjectOfPlan"
                                id="formerTenureSubjectOfPlan"
                                [value]="option.id"
                                [(ngModel)]="model.formerTenureSubjectOfPlan"
                                (ngModelChange)="formerTenureSubjectOfPlanChanged(option.id)"
                                required />
                            <span>{{option.description}}</span>
                        </label>
                    }
                </div>
            </div>
        </div>
    }

    <table class="table table-hover table-striped">
        <thead>
            <tr class="default">
                <th class="text-nowrap">Parent plan type</th>
                <th class="text-nowrap">Parent plan</th>
                <th class="text-nowrap">Parent lot/s</th>
                <th class="text-nowrap">Title reference</th>
                <th class="text-nowrap">Subject land desc</th>
                <th class="text-nowrap">Locality</th>
                <th>&nbsp;</th>
            </tr>
        </thead>
        @for (formerTenureViewModel of formerTenureViewModels; track formerTenureViewModel; let j = $index) {
            <tbody>
                @if (formerTenureViewModel.lotRanges.length == 0) {
                    <tr>
                        <td>
                            <span>{{getParentPlanTypeName(formerTenureViewModel.parentPlanType)}}</span>
                        </td>
                        <td>
                            <span>{{formerTenureViewModel.parentPlanNumber}}</span>
                        </td>
                        <td>&nbsp;</td>
                        <td>
                            <span>{{formerTenureViewModel.title}}</span>
                        </td>
                        <td>
                            <span>{{formerTenureViewModel.subjectLandDescription}}</span>
                        </td>
                        <td>&nbsp;</td>
                        <td>
                            <i
                                class="nlrp-icon nlrp-icon-edit"
                                tabindex="0"
                                (click)="openFormerTenureModal()"></i>
                        </td>
                    </tr>
                }
                @for (lotRange of formerTenureViewModel.lotRanges; track lotRange; let i = $index) {
                    <tr
                        ><td>
                            @if (i===0) {
                                <span>{{getParentPlanTypeName(formerTenureViewModel.parentPlanType)}}</span>
                            }
                        </td>
                        <td>
                            @if (i===0) {
                                <span>{{formerTenureViewModel.parentPlanNumber}}</span>
                            }
                        </td>
                        <td
                            ><span
                                >{{lotRange.to > lotRange.from ? (lotRange.prefixFrom + lotRange.from + '-' + lotRange.prefixTo + lotRange.to) : lotRange.prefixFrom + lotRange.from}}</span
                            ></td
                        >
                        <td>
                            <span>{{lotRange.title}}</span>
                        </td>
                        <td>&nbsp;</td>
                        <td>
                            <span>{{lotRange.locality}}</span>
                        </td>
                        <td>
                            <i
                                class="nlrp-icon nlrp-icon-edit"
                                tabindex="0"
                                (click)="openFormerTenureModal()"></i>
                        </td>
                    </tr>
                }
            </tbody>
        }
    </table>

    <div class="row">
        <div class="col-xs-12">
            <button
                type="button"
                class="btn btn-default nlr-btn-sm"
                (click)="openFormerTenureModal()"
                #addFormerTenure
                id="addFormerTenure"
                title="Add former tenure"
                >Add
            </button>
        </div>
    </div>
    @if (isModalOpen) {
        <nlr-former-tenure-modal
            (modalCloseEvent)="dismissModal()"
            (modalSaveEvent)="saveModalData()"></nlr-former-tenure-modal>
    }

    @if (!hasMinFormerTenures() && submitted) {
        <div class="row">
            <div class="col-xs-12">
                <input
                    type="checkbox"
                    name="hasMinFormerTenures"
                    id="hasMinFormerTenures"
                    class="hidden"
                    [(ngModel)]="model.hasMinFormerTenures"
                    ng-model="$ctrl.model.hasMinFormerTenures"
                    required />
                <div class="help-block">
                    <span>Error!</span>
                    <span>At least one former tenure must be provided.</span>
                </div>
            </div>
        </div>
    }
</div>
